import './App.css';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import Home from './pages/Home/Home';
import Allworks from './pages/allworks/Allworks';
import AllSketches from './pages/sketches/AllSketches';
import ContactPage from './pages/contactpage/ContactPage';
import ProjectView from './pages/projectView/ProjectView';
import { useEffect, useState } from 'react';
import AboutPage from './pages/aboutPage/AboutPage';
import { GridViewProvider } from './components/GridViewContext';
import Popup from './components/popup/Popup';
import Error from './pages/error/Error';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
      window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  const [showPopup, setShowPopup] = useState(false);
  const [loadFinished, setLoadFinished] = useState(false);
  
  useEffect(() => {
    if (!loadFinished) {
      setTimeout(() => {
        setLoadFinished(true);
      }, 3000);
    }
    if (window.location.pathname === "/" && !showPopup) {
      setTimeout(() => {
        setShowPopup(true);
      }, 1000);
    }
  }, [loadFinished, showPopup]);

  return (
    <div className="App">
      <GridViewProvider>
      <Router>
        <ScrollToTop />
        {showPopup && <Popup/>}
        <Routes>
          <Route path='/' element={<Home loaderFinished={loadFinished} setLoaderFinished={setLoadFinished}/>}/>
          <Route path='/work' element={<Allworks loaderFinished={loadFinished} setLoaderFinished={setLoadFinished}/>}/>
          <Route path='/sketches' element={<AllSketches loaderFinished={loadFinished} setLoaderFinished={setLoadFinished}/>}/>
          <Route path='/contact' element={<ContactPage loaderFinished={loadFinished} setLoaderFinished={setLoadFinished}/>}/>
          <Route path='/work/:projectTitle' element={<ProjectView loaderFinished={loadFinished} setLoaderFinished={setLoadFinished}/>}/>
          <Route path='/about' element={<AboutPage loaderFinished={loadFinished} setLoaderFinished={setLoadFinished}/>}/>
          <Route path='*' element={<Navigate to='/error' />} />
          <Route path='/error' element={<Error />} />
        </Routes>
      </Router>
      </GridViewProvider>
    </div>
  );
}

export default App;
